export interface PaginatorData {
  length: number;     // total
  pageIndex: number;  // offset
  pageSize: number;   // limit
  previousPageIndex: number;
}
